import React from "react";
import TraguardiSportivi from "./TraguardiSportivi";

// Tab «Traguardi» della scheda del player: tutto in TraguardiSportivi, uguale per il junior
const TraguardiPlayer = (props) => <TraguardiSportivi userId={props.profile?.idsPlay?.userId} />;

export default TraguardiPlayer;
